module.exports = __webpack_public_path__ + "static/media/java.83483822.png";